import { Component, forwardRef, Injector, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig, RenderComponentBase } from '../../../dynamic-component';

@Component({
  selector: 'app-r-con-boolean',
  templateUrl: './r-con-boolean.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RConBooleanComponent),
      multi: true
    }
  ]
})
export class RConBooleanComponent extends RenderComponentBase {
  static KEY = 'r-d-con-boolean';

  constructor(injector: Injector) {
    super(injector);
  }

  configChange(config: IDynamicComponentConfig) {
    if (!Array.isArray(config.dataSource)) {
      config.dataSource = [
        {
          value: true,
          label: '是'
        },
        {
          value: false,
          label: '否'
        }
      ];
    }
  }
}
